import { Phone } from 'lucide-react'
import { useLocale } from '../i18n/LocaleContext'
import { track } from '../lib/analytics'

// Small floating call button (bottom-right, all pages). Links to the same phone
// number shown in the footer (t.contact.info.phone).
export default function FloatingCallButton() {
  const { locale, t } = useLocale()
  const phone = t.contact.info.phone
  const tel = phone.replace(/\s/g, '')
  const label = locale === 'hu' ? 'Hívjon minket' : 'Sunați-ne'

  return (
    <a
      href={`tel:${tel}`}
      onClick={() => track('phone_click', { location: 'floating_button' })}
      aria-label={`${label}: ${phone}`}
      title={phone}
      className="fixed bottom-5 right-5 z-40 flex h-14 w-14 items-center justify-center rounded-full bg-primary text-white shadow-hover transition-colors hover:bg-primary-hover focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2"
    >
      <Phone size={24} />
    </a>
  )
}
